import contactsList from "./list.vue"
let a = Object.assign({ contactsList })
export default a